import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

const InstitutionalGroup = () => {
	return {
		componentName: 'VisibilityLayout',
		componentGroup: 'InstitutionalGroup',
		componentId: uuidv4(),
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Conteúdo Institucional (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'img-and-text__row-container-1',
					preserveLayoutOnMobile: true,
					mzTitle: 'MZ | Conteúdo Institucional',
				},
				[
					FlexLayoutCol({ width: { desktop: 'grow', mobile: '100%' }, blockClass: 'img-and-text__text-col-1' }, [
						RichText({
							mzTitle: 'MZ | Texto',
							blockClass: 'img-and-text__text-1',
							text: 'Texto de **Exemplo**\n\n\n Digite aqui seu texto',
						}),
					]),
					FlexLayoutCol({ width: { desktop: 'grow', mobile: '100%' }, blockClass: 'img-and-text__img-col-1' }, [
						Image({
							blockClass: 'img-and-text__image-1',
							src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060245014-Slider-Banner-Mobile.png',
						}),
					]),
				],
			),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--iat-1-bg-color', name: 'Background' },
			{ from: '--text-color-1', to: '--iat-1-text-color', name: 'Text' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-none', to: '--iat-1-img-border', name: 'Image' }],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--iat-1-typography', name: 'Text' }],
	},
];
export default InstitutionalGroup;
